// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { DnsZoneWithRelationsSchema } from './DnsZoneRelationsSchema'
import type { DnsZoneWithRelations } from './DnsZoneRelationsSchema'
import { DnsZoneRecordSchema } from './DnsZoneRecordSchema';

/////////////////////////////////////////
// DNS ZONE RECORD RELATION SCHEMA
/////////////////////////////////////////

export type DnsZoneRecordRelations = {
  zone: DnsZoneWithRelations;
};

export type DnsZoneRecordWithRelations = z.infer<typeof DnsZoneRecordSchema> & DnsZoneRecordRelations

export const DnsZoneRecordWithRelationsSchema: z.ZodType<DnsZoneRecordWithRelations> = DnsZoneRecordSchema.merge(z.object({
  zone: z.lazy(() => DnsZoneWithRelationsSchema),
}))